import React from 'react';

export const OutsideWindow = (
  props: React.SVGProps<SVGSVGElement>,
): JSX.Element => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 96.45 65.55"
      {...props}
    >
      <g id="Group_75" data-name="Group 75">
        <g id="Group_37" data-name="Group 37">
          <g id="Group_615" data-name="Group 615">
            <rect
              id="Rectangle_111"
              data-name="Rectangle 111"
              fill="#fff"
              x="5.5"
              y="4.33"
              width="85.71"
              height="60.66"
            />
            <path
              id="Path_2469"
              data-name="Path 2469"
              fill="#dcd9d5"
              d="M91.21,65.55H5.5A.57.57,0,0,1,4.93,65V4.33a.57.57,0,0,1,.57-.57H91.21a.56.56,0,0,1,.57.57h0V65A.56.56,0,0,1,91.21,65.55ZM6.07,64.42H90.65V4.9H6.07Z"
            />
          </g>
          <g id="Group_616" data-name="Group 616">
            <rect
              id="Rectangle_112"
              data-name="Rectangle 112"
              fill="#fff"
              x="5.5"
              y="4.33"
              width="85.71"
              height="60.66"
            />
            <path
              id="Path_2470"
              data-name="Path 2470"
              fill="#dcd9d5"
              d="M91.21,65.55H5.5A.57.57,0,0,1,4.93,65V4.33a.57.57,0,0,1,.57-.57H91.21a.56.56,0,0,1,.57.57h0V65A.56.56,0,0,1,91.21,65.55ZM6.07,64.42H90.65V4.9H6.07Z"
            />
          </g>
          <g id="Group_617" data-name="Group 617">
            <rect
              id="Rectangle_113"
              data-name="Rectangle 113"
              fill="#dcd9d5"
              x="9.5"
              y="8.33"
              width="77.71"
              height="52.66"
            />
            <path
              id="Path_2471"
              data-name="Path 2471"
              fill="#dcd9d5"
              d="M87.21,61.55H9.5A.57.57,0,0,1,8.93,61V8.33a.57.57,0,0,1,.57-.57H87.21a.56.56,0,0,1,.57.57h0V61A.56.56,0,0,1,87.21,61.55ZM10.07,60.42H86.64V8.89H10.07Z"
            />
          </g>
          <path
            id="Path_2472"
            data-name="Path 2472"
            fill="#dcd9d5"
            d="M95.54,65.52H1.18A.54.54,0,0,1,.64,65h0a.54.54,0,0,1,.54-.54H95.54a.54.54,0,0,1,.53.54h0A.53.53,0,0,1,95.54,65.52Z"
          />
        </g>
      </g>
      <rect fill="#27375f" x="0.27" y="0.27" width="95.91" height="3.93" />
      <path
        fill="#fff"
        d="M95.91.53v3.4H.54V.53H95.91M96.45,0H0V4.46H96.45V0Z"
      />
      <rect fill="#27375f" x="0.19" y="39.68" width="96.07" height="2.08" />
      <path
        fill="#fff"
        d="M96.07,39.87v1.7H.38v-1.7H96.07m.38-.38H0v2.45H96.45V39.49Z"
      />
      <rect fill="#27375f" x="0.27" y="4.44" width="95.91" height="3.24" />
      <path
        fill="#fff"
        d="M95.91,4.7V7.41H.54V4.7H95.91m.53-.53H0V7.94H96.44V4.17Z"
      />
      <polygon
        fill="#27375f"
        points="0.32 11.32 0.27 8.08 96.18 8.08 96.18 11.32 0.32 11.32"
      />
      <path
        fill="#fff"
        d="M95.91,8.34v2.71H.58l0-2.71H95.91m.53-.53H0v.54l0,2.71v.52H96.44V7.81Z"
      />
      <rect fill="#27375f" x="0.27" y="11.44" width="95.91" height="3.24" />
      <path
        fill="#fff"
        d="M95.91,11.71v2.71H.54V11.71H95.91m.53-.53H0V15H96.44V11.18Z"
      />
      <polygon
        fill="#27375f"
        points="0.32 18.32 0.27 15.08 96.18 15.08 96.18 18.32 0.32 18.32"
      />
      <path
        fill="#fff"
        d="M95.91,15.35v2.71H.58l0-2.71H95.91m.53-.53H0v.54l0,2.71v.52H96.44V14.82Z"
      />
      <rect fill="#27375f" x="0.27" y="18.52" width="95.91" height="3.24" />
      <path
        fill="#fff"
        d="M95.91,18.79V21.5H.54V18.79H95.91m.53-.53H0V22H96.44V18.26Z"
      />
      <polygon
        fill="#27375f"
        points="0.32 25.4 0.27 22.16 96.18 22.16 96.18 25.4 0.32 25.4"
      />
      <path
        fill="#fff"
        d="M95.91,22.43v2.71H.58l0-2.71H95.91m.53-.53H0v.54l0,2.71v.52H96.44V21.9Z"
      />
      <rect fill="#27375f" x="0.27" y="25.53" width="95.91" height="3.24" />
      <path
        fill="#fff"
        d="M95.91,25.8v2.71H.54V25.8H95.91m.53-.53H0V29H96.44V25.27Z"
      />
      <polygon
        fill="#27375f"
        points="0.32 32.41 0.27 29.18 96.18 29.18 96.18 32.41 0.32 32.41"
      />
      <path
        fill="#fff"
        d="M95.91,29.44v2.71H.58l0-2.71H95.91m.53-.53H0v.54l0,2.71v.52H96.44V28.91Z"
      />
      <rect fill="#27375f" x="0.27" y="32.4" width="95.91" height="3.24" />
      <path
        fill="#fff"
        d="M95.91,32.66v2.71H.54V32.66H95.91m.53-.53H0V35.9H96.44V32.13Z"
      />
      <polygon
        fill="#27375f"
        points="0.32 39.28 0.27 36.04 96.18 36.04 96.18 39.28 0.32 39.28"
      />
      <path
        fill="#fff"
        d="M95.91,36.31V39H.58l0-2.71H95.91m.53-.53H0v.53L.05,39v.53H96.44V35.78Z"
      />
    </svg>
  );
};
